import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

function load(component) {
    return () => import(/* webpackChunkName: "[request]" */ `@/views/${component}.vue`);
}

const routes = [
    // {
    //     path: '/',
    //     name: 'dashboard',
    //     component: load('Dashboard'),
    //     meta: { title: 'Dashboard' },
    // },
    {
        path: '/users',
        name: 'users',
        component: load('admin/users/Users'),
        meta: { title: 'Users' },
    },
    {
        path: '/users/:id',
        name: 'users.details',
        component: load('admin/users/UserDetails'),
        meta: { title: 'User Details' },
        props: true,
    },
    {
        path: '/',
        name: 'businesses',
        component: load('admin/businesses/Businesses'),
        meta: { title: 'Businesses' },
    },
    {
        path: '/settings',
        name: 'settings',
        component: load('admin/Settings'),
        meta: { title: 'Settings' },
    },
    {
        path: '/business/create',
        name: 'businesses.create',
        component: load('admin/businesses/EditBusiness'),
        meta: { title: 'Create Business' },
    },
    {
        path: '/businesses/:id',
        name: 'businesses.details',
        component: load('admin/businesses/Business'),
        meta: {},
        props: true,
        redirect: { name: 'info' },
        children: [
            {
                path: 'info',
                name: 'info',
                component: load('admin/businesses/business/Info'),
                meta: { toolbar: true },
                props: true,
            },
            {
                path: 'edit',
                name: 'businesses.edit',
                component: load('admin/businesses/EditBusiness'),
                meta: { toolbar: true },
                props: true,
            },
            {
                path: 'menu',
                name: 'menu',
                component: load('admin/businesses/business/Menus'),
                meta: { toolbar: true },
                props: true,
            },
            {
                path: 'menu/:menuId/categories',
                name: 'menu-categories',
                component: load('admin/businesses/business/MenuCategories'),
                meta: { toolbar: true },
                props: true,
            },
            {
                path: 'menu/:menuId/category/:categoryId/products',
                name: 'businesses.menu-category-products',
                component: load('admin/businesses/business/MenuCategoryProducts'),
                meta: { toolbar: true },
                props: true,
            },
        ],
    },
    {
        path: '/tags',
        name: 'tags',
        component: load('admin/tags-management/Tags'),
        meta: { title: 'Tags' },
    },
    {
        path: '/activity-logs',
        name: 'activityLogs',
        component: load('admin/activity-logs/ActivityLogs'),
        meta: { title: 'Activity Logs' },
    },
    {
        path: '/proposals',
        name: 'proposals',
        component: load('admin/proposals/Proposals'),
        meta: { title: 'Proposals' },
    },
    {
        path: '/suggestions',
        name: 'suggestions',
        component: load('admin/suggestions/Suggestions'),
        meta: { title: 'Suggestions' },
    },
    {
        path: '/giveaways',
        name: 'giveaways',
        component: load('giveaways/Giveaways'),
        meta: { title: 'Giveaways' },
    },
    {
        path: '/giveaways/create',
        name: 'giveaways.create',
        component: load('giveaways/GiveawayEdit'),
        meta: { title: 'Giveaways > Create' },
    },
    {
        path: '/giveaways/:id',
        name: 'giveaways.details',
        component: load('giveaways/GiveawayDetails'),
        meta: { title: 'Giveaways > Details' },
        props: true,
    },
    {
        path: '/giveaways/:id/edit',
        name: 'giveaways.edit',
        component: load('giveaways/GiveawayEdit'),
        meta: { title: 'Giveaways > Edit' },
        props: true,
    },
    {
        path: '/login',
        name: 'login',
        component: load('authentication/Login'),
        meta: {
            title: 'Login',
            requiresAuth: false,
        },
    },
    {
        path: '/500',
        name: 'error500',
        component: load('Error500'),
        meta: {
            title: '500',
            requiresAuth: false,
        },
    },
    {
        path: '*',
        name: 'error404',
        component: load('Error404'),
        meta: {
            title: '404',
            requiresAuth: false,
        },
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior: (to, from, savedPosition) => {
        if (savedPosition) {
            return savedPosition;
        }
        if (to.hash) {
            return { selector: to.hash };
        }
        return { x: 0, y: 0 };
    },
    routes,
});

// Adjust window title, based on route title
router.beforeEach((to, from, next) => {
    // 1. Redirect login/register routes to "/" if user is already logged in
    if (store.state.signedIn && to.name === 'login') {
        return next('/');
    }

    // 2. If route doesn't require authentication, or user is signed-in, allow access
    if (to.meta.requiresAuth === false || store.state.signedIn) {
        // If document is in place (false only for SSR), ådjust tab title based on meta.title
        if (document) {
            const title = to.meta.title || to.name;
            document.title = `Pempo Admin - ${title}`;
        }

        return next();
    }

    // 3. For all other cases, redirect to the Login page
    return next('/login');
});

export default router;
